import configureStore from './redux/configure-store';

export const createStore = configureStore;
